export default {
  HAPPINESS_OVERVIEW: "HAPPINESS_OVERVIEW",
  HAPPINESS_SUBMITTER: "HAPPINESS_SUBMITTER",
  MANAGER_PAGE: "MANAGER_PAGE",
  DASHBOARD_PAGE: "DASHBOARD_PAGE",
};



// WEBPACK FOOTER //
// ./src/modules/menu/menuOptions.js